import { Keyword } from './Keyword';
import _ from 'lodash';
import {
  LimitationWebService,
  RestfulLimitationWebService
} from 'ws/LimitationWebService';
import { RestfulBlobWebService } from 'ws/BlobWebService';
import { RestfulGCPCloudStorageWebService } from 'ws/GCPCloudStorageWebService';
import config from 'config';
import { CloudResourceWebService } from 'ws/CloudResourceWebService';
import { SavedTargeting } from './Limitation';
import { OrderType } from 'core/order/Order';

const defaultlimitationJson = {
  include: [],
  exclude: [],
  preferred: [],
  nonPreferred: [],
  other: [
    {
      op: 'inc',
      value: [],
      type: 'dealId'
    }
  ]
};

export interface LimitationManager {
  keywordEstimate(request: Keyword): Promise<number>;
  getLimitationPreSet(type: string): Promise<object>;
  categoriesUnionCount(
    categories: Array<string>,
    lang?: string
  ): Promise<number>;
  getSavedTargetings(
    advertiserId: number,
    channel: string,
    adsOrderType: OrderType
  ): Promise<SavedTargeting[]>;
  createSavedTargeting(
    savedTargeting: Partial<SavedTargeting>,
    adsOrderType: OrderType
  ): Promise<SavedTargeting>;
  updateSavedTargeting(
    savedTargeting: Partial<SavedTargeting>,
    adsOrderType: OrderType
  ): Promise<SavedTargeting>;
  deleteSavedTargeting(id: number): Promise<void>;
}

export class DefaultLimitationManager implements LimitationManager {
  webService: LimitationWebService;
  cloudStorageWebService: CloudResourceWebService;

  constructor(
    webService: LimitationWebService = new RestfulLimitationWebService(),
    cloudStorageWebService: CloudResourceWebService = config.cloudStorageConfig
      .platform === 'azure'
      ? new RestfulBlobWebService()
      : new RestfulGCPCloudStorageWebService()
  ) {
    this.webService = webService;
    this.cloudStorageWebService = cloudStorageWebService;
  }

  keywordEstimate(request: Keyword): Promise<number> {
    return this.webService.keywordEstimate(request);
  }

  async categoriesUnionCount(
    categories: Array<string>,
    lang = 'zh'
  ): Promise<number> {
    return this.webService.categoriesUnionCount(categories, lang);
  }

  async getLimitationPreSet(type: string): Promise<object> {
    const opMap = {
      inc: 'include',
      exc: 'exclude',
      Preferred: 'preferred',
      NonPreferred: 'nonPreferred'
    };

    let limitationPreSet: any;
    try {
      const cloudLimitationPreSet =
        await this.cloudStorageWebService.getLimitationPreSet(type);
      limitationPreSet = _.isEmpty(cloudLimitationPreSet)
        ? _.cloneDeep(defaultlimitationJson)
        : cloudLimitationPreSet;
    } catch {}
    if (type === 'creative') {
      return limitationPreSet;
    }
    const agencyLimitationPreSet =
      await this.webService.getAgencyLimitationPreSet(type);
    agencyLimitationPreSet.forEach((element) => {
      element.value = element.limits
        ? element.limits.map((limit) => ({
            ...limit,
            isGroup: element.isGroup ? element.isGroup : false
          }))
        : [];
      delete element['limits'];
      if (element.type === 'instl') {
        const instlElement = {
          op: 'exc',
          type: 'adFormat',
          value: [
            {
              value: 'instl',
              label: 'instl'
            }
          ]
        };
        const excludePreSet = _.defaultTo(limitationPreSet['exclude'], []);
        excludePreSet.push(instlElement);
        limitationPreSet['exclude'] = excludePreSet;
        return;
      }
      let setIndex = limitationPreSet[opMap[element.op]].findIndex(
        (set) => set.type === element.type
      );
      if (setIndex === -1) {
        limitationPreSet[opMap[element.op]].push(element);
        return;
      }
      limitationPreSet[opMap[element.op]][setIndex] = element;
    });
    return limitationPreSet;
  }

  async getSavedTargetings(
    advertiserId: number,
    channel: string,
    adsOrderType: OrderType
  ): Promise<SavedTargeting[]> {
    return this.webService.getSavedTargetings(
      advertiserId,
      channel,
      adsOrderType
    );
  }
  async createSavedTargeting(
    savedTargeting: Partial<SavedTargeting>,
    adsOrderType: OrderType
  ): Promise<SavedTargeting> {
    return this.webService.createSavedTargeting(savedTargeting, adsOrderType);
  }
  async updateSavedTargeting(
    savedTargeting: Partial<SavedTargeting>,
    adsOrderType: OrderType
  ): Promise<SavedTargeting> {
    return this.webService.updateSavedTargeting(savedTargeting, adsOrderType);
  }
  async deleteSavedTargeting(id: number): Promise<void> {
    return this.webService.deleteSavedTargeting(id);
  }
}
